import React, { ReactNode, useMemo, useState } from 'react';

import { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';

import {
  type SitterProfileVersion,
  type ViewMode,
  RevampProfileContext,
} from '../hooks/useRevampProfileContext';

interface RevampProfileProviderProps {
  children: ReactNode;
  serviceType: string | undefined;
  setServiceType: (serviceType: string) => void;
  sitterData: EnhancedPersonSitterProfile;
  viewMode: ViewMode;
  pageTreatment: SitterProfileVersion;
  contactUrl: string;
}

export const RevampProfileProvider = ({
  children,
  serviceType,
  setServiceType,
  sitterData,
  viewMode,
  pageTreatment,
  contactUrl,
}: RevampProfileProviderProps): JSX.Element => {
  const [reviewsModalOpen, setReviewsModalOpen] = useState(false);

  const contextValue = useMemo(
    () => ({
      serviceType,
      setServiceType,
      sitterData,
      viewMode,
      pageTreatment,
      reviewsModalOpen,
      setReviewsModalOpen,
      contactUrl,
    }),
    [serviceType, setServiceType, sitterData, viewMode, pageTreatment, reviewsModalOpen, contactUrl]
  );

  return (
    <RevampProfileContext.Provider value={contextValue}>{children}</RevampProfileContext.Provider>
  );
};
